/**
 * Shows a form field only when a controlling <select> has a given value.
 * Without JavaScript the field stays visible, so nothing is ever lost.
 * Hidden fields are disabled so they are not submitted.
 */
class ConditionalField extends HTMLElement {
  connectedCallback() {
    const formEl = this.closest('form');
    const controlName = this.dataset.conditionalOn;
    if (!formEl || !controlName) return;

    this.control = formEl.querySelector(`[name="${CSS.escape(controlName)}"]`);
    if (!this.control) return;

    this.control.addEventListener('change', this.update);
    this.update();
  }

  disconnectedCallback() {
    this.control?.removeEventListener('change', this.update);
  }

  update = () => {
    const show = this.control.value === this.dataset.conditionalValue;
    this.hidden = !show;
    for (const input of this.querySelectorAll('input, select, textarea')) {
      input.disabled = !show;
    }
  };
}

if (!customElements.get('conditional-field')) {
  customElements.define('conditional-field', ConditionalField);
}
